export const smoothScrollToPosition = (element: HTMLDivElement | null, top: number = 0) => {
  if (element) {
    try {
      element.scrollTo({
        top,
        left: 0,
        behavior: 'smooth',
      });
    } catch (e) {
      element.scrollTo(0, top);
    }
  }
};
